import LArtwork from "@components/LArtwork";

import LBox from "@components/LBox";
import { LArtworkProps } from "@components/LArtwork";
import LLink from "@components/LLink";
import { Href } from "expo-router";
import { Dimensions } from "react-native";
import { theme } from "@theme";
import LText from "@components/LText";
import { LinearGradient } from "expo-linear-gradient";
import { getViewPort } from "@utils/web/config";

const window = Dimensions.get("window");
const { width } = getViewPort(window);

interface TileUIProps {
  title: string;
  images: LArtworkProps["url"];
  href: Href;
}

const UI = ({ title, images, href }: TileUIProps) => {
  return (
    <LLink href={href} sentryEventName="songs_favourites_tile">
      <LBox
        flex={1}
        height={60}
        minHeight={60}
        overflow="hidden"
        justifyContent="flex-end"
        alignItems="center"
        pb="s1"
        borderRadius="s-m"
      >
        <LArtwork
          imageSize="medium"
          size={width / 2 - theme.spacing.s3}
          url={images}
          position="absolute"
          top={0}
          flexDirection={"row"}
          playlistHorizontal
        />
        <LinearGradient
          colors={[
            "transparent",
            theme.colors.favouriteTileBg,
            theme.colors.favouriteTileBg,
          ]}
          style={{
            width: "100%",
            height: 60,
            position: "absolute",
            top: 0,
          }}
          start={{ x: 0, y: 0 }}
          end={{ x: 0, y: 1 }}
          locations={[0.55, 0.8, 1]}
        />
        <LBox justifyContent="center" maxWidth="80%">
          <LText color="homeLibraryItemText" numberOfLines={1} variant="bodyM">
            {title}
          </LText>
        </LBox>
        <LBox
          borderRadius="s-m"
          borderWidth={1}
          borderColor="whiteBorder"
          position="absolute"
          top={0}
          left={0}
          bottom={0}
          right={0}
        />
      </LBox>
    </LLink>
  );
};

export default UI;
